import { Confirm, Button, Icon } from "semantic-ui-react";
import React, { useState } from 'react';

const ConfirmDelete = ({ onDelete, plantName }: { onDelete: Function, plantName: String }) => {
    const [open, setOpen] = useState(false);

    const onConfirm = async () => {
        setOpen(false);
        await onDelete();
    }
    return (
        <>
            <Button title="delete plant" icon color="red" floated="right" onClick={() => {setOpen(true)}}>
                <Icon name="trash" />
            </Button>
            <Confirm 
                open={open}
                onCancel={() => setOpen(false)}
                onConfirm={onConfirm}
                content={`Are you sure you would like to delete ${plantName}?`}
                header="Delete Plant"
                confirmButton="Yes, delete it."
                cancelButton="No, nevermind."
            />
        </>
    )
};

export default ConfirmDelete;